import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import EngineerLayout from './EngineerLayout';
import { 
    FaArrowLeft, 
    FaSearch,
    FaFilePdf,
    FaPrint,
    FaEye,
    FaSort
} from 'react-icons/fa';

const EngineerSocietyLotteryListReport = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);

    // Data from the image
    useEffect(() => {
        const mockData = [
            { id: "२९०", societyName: "साईनाथ मजूर सहकारी संस्था मर्यादित", inwardNo: "१०३४४", date: "२०२६-०२-२६", file: "ddr_1.pdf" },
            { id: "२८९", societyName: "श्री राजेश मजूर सहकारी संस्था लिमिटेड", inwardNo: "६२९०", date: "२०२६-०२-२७", file: "ddr_2.pdf" },
            { id: "२८८", societyName: "दिलासा मजूर सहकारी संस्था मर्यादित", inwardNo: "१०२५८", date: "२०२६-०२-२४", file: "ddr_3.pdf" },
            { id: "२८७", societyName: "श्री गोसावीबाबा मजूर सहकारी संस्था मर्यादित", inwardNo: "१०२६१", date: "२०२६-०२-२४", file: "ddr_4.pdf" },
            { id: "२८६", societyName: "हरिकृष्ण मजूर सहकारी संस्था लिमिटेड", inwardNo: "१०२५९", date: "२०२६-०२-२४", file: "ddr_5.pdf" },
            { id: "२८५", societyName: "श्री अविनाश कामगार सहकारी संस्था मर्या", inwardNo: "१०२६०", date: "२०२६-०२-२४", file: "ddr_6.pdf" },
            { id: "२८४", societyName: "इंद्रायणी मजूर सहकारी संस्था", inwardNo: "१०२१७", date: "२०२६-०२-२०", file: "ddr_7.pdf" },
            { id: "२८३", societyName: "श्री ज्ञानराज कामगार सहकारी संस्था मर्यादित", inwardNo: "१०१०८", date: "२०२६-०२-१९", file: "ddr_8.pdf" },
        ];
        setData(mockData);
        setLoading(false);
    }, []);

    const filteredData = data.filter(item => 
        item.societyName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.id.includes(searchTerm) ||
        item.inwardNo.includes(searchTerm)
    );

    return (
        <EngineerLayout>
            <div className="p-6 md:p-8 bg-gray-50/50 min-h-screen">
                {/* Header Section */}
                <div className="flex justify-between items-center mb-8 px-2 font-marathi">
                    <div className="flex items-center gap-4">
                        <button 
                            onClick={() => navigate('/engineer/society-menu')}
                            className="p-2 bg-white rounded-full shadow-sm hover:bg-gray-50 transition text-gray-600 border border-gray-100"
                        >
                            <FaArrowLeft size={16} />
                        </button>
                        <h1 className="text-xl font-bold text-gray-800 tracking-tight">अपलोड डीडीआर पत्रक पहा</h1>
                    </div>
                    <div className="text-xs font-medium text-gray-400">
                        जिल्हा परिषद / <span className="text-gray-500 font-bold">अपलोड डीडीआर पत्रक पहा</span>
                    </div>
                </div>

                {/* Main Card */}
                <div className="bg-white rounded-xl shadow-md border border-gray-100 p-8 overflow-hidden">
                    {/* Toolbar */}
                    <div className="flex flex-col md:flex-row justify-between items-center gap-6 mb-8">
                        <div className="flex bg-gray-600 rounded overflow-hidden shadow-sm">
                            <button className="px-5 py-2 text-xs font-bold text-white hover:bg-gray-700 transition font-marathi border-r border-gray-500">कॉपी करा</button>
                            <button className="px-5 py-2 text-xs font-bold text-white hover:bg-gray-700 transition font-marathi border-r border-gray-500">एक्सेल</button>
                            <button className="px-5 py-2 text-xs font-bold text-white hover:bg-gray-700 transition font-marathi">प्रिंट</button>
                        </div>

                        <div className="flex items-center gap-3 w-full md:w-auto">
                            <label className="text-xs font-bold text-gray-500 font-marathi whitespace-nowrap">शोध:</label>
                            <div className="relative group w-full md:w-64">
                                <input 
                                    type="text" 
                                    className="w-full border border-gray-200 rounded-lg pl-3 pr-10 py-1.5 text-sm outline-none focus:border-blue-400 transition-all font-bold bg-white"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                                <FaSearch size={14} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-300 pointer-events-none group-focus-within:text-blue-500 transition-colors" />
                            </div>
                        </div>
                    </div>

                    {/* Premium Table Content */}
                    <div className="overflow-x-auto border border-gray-100 rounded-lg custom-scrollbar">
                        <table className="w-full border-collapse min-w-[1200px]">
                            <thead>
                                <tr className="bg-white border-b border-gray-200">
                                    <th className="px-4 py-4 text-[13px] font-black text-gray-800 text-left border-r border-gray-100 w-16">
                                        <div className="flex items-center gap-2"># <FaSort className="opacity-30" size={10} /></div>
                                    </th>
                                    <th className="px-4 py-4 text-[13px] font-black text-gray-800 text-left border-r border-gray-100 w-24">
                                        <div className="flex items-center gap-2">आयडी <FaSort className="opacity-30" size={10} /></div>
                                    </th>
                                    <th className="px-4 py-4 text-[13px] font-black text-gray-800 text-left border-r border-gray-100 font-marathi min-w-[350px]">
                                        <div className="flex items-center gap-2">संस्थेचे नाव <FaSort className="opacity-30" size={10} /></div>
                                    </th>
                                    <th className="px-4 py-4 text-[13px] font-black text-gray-800 text-left border-r border-gray-100 w-44">
                                        <div className="flex items-center gap-2">जाणारा क्रमांक. <FaSort className="opacity-30" size={10} /></div>
                                    </th>
                                    <th className="px-4 py-4 text-[13px] font-black text-gray-800 text-left border-r border-gray-100 w-48 font-marathi">
                                        <div className="flex items-center gap-2">टिपणी तारीख <FaSort className="opacity-30" size={10} /></div>
                                    </th>
                                    <th className="px-4 py-4 text-[13px] font-black text-gray-800 text-left border-r border-gray-100 w-36 font-marathi text-center">
                                        डीडीआर फाइल
                                    </th>
                                    <th className="px-4 py-4 text-[13px] font-black text-gray-800 text-center font-marathi w-32">
                                        कृती
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-50">
                                {loading ? (
                                    <tr>
                                        <td colSpan="7" className="px-6 py-20 text-center">
                                            <div className="w-8 h-8 border-4 border-blue-600/20 border-t-blue-600 rounded-full animate-spin mx-auto"></div>
                                        </td>
                                    </tr>
                                ) : filteredData.length === 0 ? (
                                    <tr>
                                        <td colSpan="7" className="px-6 py-12 text-center text-gray-500 font-marathi font-bold italic">
                                            कोणतीही माहिती सापडली नाही (No data found)
                                        </td>
                                    </tr>
                                ) : (
                                    filteredData.map((item, index) => (
                                        <tr key={index} className="hover:bg-blue-50/30 group transition-all duration-300 cursor-default font-marathi h-14">
                                            <td className="px-4 py-2 border-r border-gray-50 font-bold text-gray-500 text-sm">{(index + 1)}</td>
                                            <td className="px-4 py-2 border-r border-gray-50 font-bold text-gray-800 text-sm">{item.id}</td>
                                            <td className="px-4 py-2 border-r border-gray-50 font-bold text-gray-700 leading-relaxed text-sm">{item.societyName}</td>
                                            <td className="px-4 py-2 border-r border-gray-50 font-bold text-gray-600 text-sm">{item.inwardNo}</td>
                                            <td className="px-4 py-2 border-r border-gray-50 font-bold text-gray-500 text-sm italic">{item.date}</td>
                                            <td className="px-4 py-2 border-r border-gray-50 text-center">
                                                <button className="text-red-500 hover:text-red-700 hover:scale-125 transition-all">
                                                    <FaFilePdf size={20} />
                                                </button>
                                            </td>
                                            <td className="px-4 py-2 text-center">
                                                <div className="flex items-center justify-center gap-4">
                                                    <button 
                                                        onClick={() => navigate('/engineer/ddr-certificate')}
                                                        className="text-blue-500 hover:text-blue-700 transition" 
                                                        title="View Detail"
                                                    >
                                                        <FaEye size={16} />
                                                    </button>
                                                    <button 
                                                        onClick={() => navigate('/engineer/generate-certificate')}
                                                        className="text-gray-600 hover:text-gray-900 transition" 
                                                        title="Print File"
                                                    >
                                                        <FaPrint size={16} />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <style>{`
                .custom-scrollbar::-webkit-scrollbar {
                    height: 8px;
                }
                .custom-scrollbar::-webkit-scrollbar-track {
                    background: transparent;
                }
                .custom-scrollbar::-webkit-scrollbar-thumb {
                    background: #e2e8f0;
                    border-radius: 20px;
                    border: 2px solid transparent;
                    background-clip: content-box;
                }
                .custom-scrollbar::-webkit-scrollbar-thumb:hover {
                    background: #cbd5e1;
                    background-clip: content-box;
                }
                .font-marathi {
                    font-family: 'Hind', sans-serif;
                }
                @import url('https://fonts.googleapis.com/css2?family=Hind:wght@400;500;600;700&display=swap');
            `}</style>
        </EngineerLayout>
    );
};

export default EngineerSocietyLotteryListReport;
